<template>
  <div class="card mb-25 p-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5>Ajouter Bon de Retour (Zone)</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div class="col-md-9">
          <div class="form-group mb-3">
            <label>Zone :</label>
            <v-select
              class="custom-select-height"
              :options="agencyList"
              v-model="agency"
              label="name"
            >
              <template #option="{ name, nb_colis }">
                <span>{{ name }} - {{ nb_colis }} Colis</span>
              </template>
            </v-select>
          </div>
        </div>
        <div class="col-md-3">
          <button
            class="btn btn-primary"
            @click="addReturnNote"
            v-if="auth.can('ADD_BR_Z')"
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { onMounted } from "vue";
import { ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    // Declare reactive variables
    const agencyList = ref<Array<any>>([]);
    const agency = ref<any>({});
    const isLoader = ref(false);

    async function addReturnNote() {
      if (Object.keys(agency.value).length === 0) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
        return;
      }
      const data = new FormData();
      data.append("type", "1");
      data.append("agency_id", agency.value.id);
      data.append("agency_name", agency.value.name);
      data.append("user_id", user?.id);
      data.append("user_name", user?.name);

      isLoader.value = true;
      try {
        const res = await api.post(`/api/auth/add_brn_agency`, data);
        isLoader.value = false;
        if (res.data.message === "success") {
          const routeData = router.resolve({
            name: "EditReturnZonePage",
            params: { id: res.data.RtnNote.id, refNote: res.data.RtnNote.note_ref },
          });
          window.open(routeData.href, "_blank");
        }
      } catch (error) {
        isLoader.value = false;
        showToast("Something went wrong! Please try again", "error");
      }
    }

    onMounted(async () => {
      // Load agencies list on mount
      try {
        const res = await api.get("/api/auth/list_agencies_return");
        agencyList.value = res.data;
      } catch (error) {
        showToast("Impossible de charger les agences", "error");
      }
    });

    return {
      agencyList,
      agency,
      isLoader,
      auth,
      addReturnNote,
    };
  },
});
</script>
